// extracted by mini-css-extract-plugin
export default {"actions":"ConsultContent__actions--QCDts"};